export default "__VITE_ASSET__D3O4qAbv__"